import * as React from 'react'
import * as styles from './ProgressBar.module.scss'

const ProgressBar = ({ progress }: { progress: number }) => {

  if (!progress || progress == 0)
    return null


  return (
    (<div className={styles.progressBarContainer}>
      <div className={styles.ProgressBar}>
        <div style={{ width: `${progress}%` }}></div>
      </div>
    </div>)
  )
}

export default ProgressBar
